import * as React from 'react';

import {CN} from '@kouch.tv/cn';
import {Animation} from '@kouch.tv/brandis-uikit';
import {RenderEngine, EngineModel} from '@kouch.tv/render-engine';

import {ICommonPropTypes} from 'src/types';

import style from './style.less';

export interface IVideoOverlayRuntimePropTypes extends ICommonPropTypes {
	id: string;
	engine: EngineModel;
	markup: string;
	isVisible?: boolean;
}

interface IVideoOverlayRuntimeStateTypes {

}

const cn = CN.create('runtime', style);

export class VideoOverlayRuntime extends React.Component<IVideoOverlayRuntimePropTypes, IVideoOverlayRuntimeStateTypes> {
	static defaultProps: Partial<IVideoOverlayRuntimePropTypes> = {
		isVisible: true,
	};

	private _node: React.RefObject<HTMLDivElement> = React.createRef();

	private _visibilityChangeAnimation: Animation.Instance;

	public shouldComponentUpdate(nextProps: Readonly<IVideoOverlayRuntimePropTypes>): boolean {
		return (
			this.props.markup !== nextProps.markup ||
			this.props.isVisible !== nextProps.isVisible
		);
	}

	public componentDidMount(): void {
		this._animateVisibilityChange(false, this.props.isVisible);
	}

	public componentDidUpdate(prevProps: Readonly<IVideoOverlayRuntimePropTypes>): void {
		this._animateVisibilityChange(prevProps.isVisible, this.props.isVisible);
	}

	public componentWillUnmount(): void {
		Animation.pause(this._visibilityChangeAnimation);
	}

	private _animateVisibilityChange = (prevIsVisible, currIsVisible) => {
		if (prevIsVisible === currIsVisible) {
			return;
		}

		Animation.pause(this._visibilityChangeAnimation);

		const nodeEl = this._node.current;

		if (!nodeEl) {
			return;
		}

		this._visibilityChangeAnimation = Animation.simple({
			targets: nodeEl,
			opacity: currIsVisible ? 1 : 0,
			duration: 300,
			easing: Animation.Easing.Predefined.EXPO_IN,
			begin: () => {
				if (!currIsVisible) {
					return;
				}

				nodeEl.style.display = '';
			},
			complete: () => {
				if (currIsVisible) {
					return;
				}

				nodeEl.style.display = 'none';
			}
		});
	}

	public render(): React.ReactNode {
		return (
			<div
				ref={this._node}
				id={this.props.id}
				className={CN.join(cn.get(), this.props.className)}
				style={this.props.style}>
				<RenderEngine
					id={this.props.id}
					engine={this.props.engine}>
					{this.props.markup}
				</RenderEngine>
			</div>
		);
	}
}
